import { SecurityConfig, AuthConfig } from './installationConfig';
import Vue from 'vue';
import App from './App.vue';
import store from './stores/store';
import './registerServiceWorker';
import config from 'devextreme/core/config';
import { i18n } from '@/plugins/i18n';
import AuthenticationService from '@/auth/AuthenticationService';
import VueKonva from 'vue-konva';
import moment from 'moment';
import 'moment/locale/nl-be';
moment.locale('nl-be');
import AxiosClient from '@/data/AxiosClient';
import Helper from '@/helpers/Helper';
import installationConfigService from './services/installationConfigService';
import getRouter from './router';
import '../public/less/styles.less';

Vue.config.productionTip = false;
Vue.use(VueKonva);

config({
  defaultCurrency: 'EUR',
  decimalSeparator: ',',
});

Vue.prototype.$auth = new AuthenticationService();
Vue.prototype.$axios = AxiosClient;
Vue.prototype.$helper = new Helper();

Vue.filter('currency', (value: number) => {
  if (!value && value !== 0) {
    return '';
  }

  value = Math.round(value * 100) / 100;

  const formattedValue = value.toLocaleString('nl-BE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return '€ ' + formattedValue;
});

Vue.filter('datetime', (value: string) => {
  if (!value || value === '') {
    return '';
  }
  return moment(value).format('DD/MM/YYYY HH:mm');
});

Vue.filter('date', (value: string) => {
  if (!value || value === '') {
    return '';
  }
  return moment(value).format('DD/MM/YYYY');
});

Vue.filter('dateFormat', (value: string) => {
  if (!value || value === '') {
    return '';
  }
  return moment(value).format('MMMM');
})

Vue.filter('textToHtml', (value: string) => {
  if (!value || value === '') {
    return '';
  }

  while (value.indexOf('\n') !== -1) {
    value = value.replace('\n', '<br />');
  }

  return value;
});

getRouter().then(async router => {
  // Process any pending Azure AD redirect before attempting authenticated calls
  await AuthConfig.msalInstance!.handleRedirectPromise();

  router.beforeEach((to, from, next) => {
    const allowUnauthorized = to.matched.some((record: any) => record.meta.allowUnauthorized);
    if (allowUnauthorized) {
      return next();
    }

    const authService = new AuthenticationService();
    const user = authService.getUser();

    if (user && to.meta && to.meta.allowedRoles) {
      let allowed = false;
      (to.meta.allowedRoles as string[]).forEach((allowedRole) => {
        if (authService.hasRole(allowedRole)) {
          allowed = true;
        }
      });

      if (!allowed) {
        return next('/unauthorized');
      }

      return next();
    }

    if (!user) {
      setTimeout(() => {
        authService.signIn();
      }, 300);
    }

    return next();
  });

  const $installationConfigService = new installationConfigService();
  const authService = new AuthenticationService();

  const mountApp = () => {
    new Vue({
      router,
      store,
      i18n,
      render: (h) => h(App),
      components: {},
    }).$mount('#app');
  };

  if (authService.getUser()) {
    $installationConfigService.init().then(mountApp);
  } else {
    mountApp();
  }
});
